import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Platform} from '@ionic/angular';
import {PerfilEnum} from '../enums/perfil.enum';
import {AuthService} from './auth.service';

export interface Page {
  url?: string;
  title: string;
  name?: string;
  showItem: boolean;
  showItemMobile: boolean;
  roles?: string[];
  badge?: number;
  isMobile?: boolean;
  children?: Page[];
}

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  user: any;
  loadingUser = false;
  private pages: Page[] = [
    {
      url: 'geral',
      title: 'Geral',
      name: 'casa',
      showItem: true,
      showItemMobile: true,
    },
    {
      url: 'painel',
      title: 'Painel',
      name: 'painel',
      showItem: true,
      showItemMobile: true,
    },
    {
      url: 'estacoes',
      title: 'Estações',
      name: 'vento',
      showItem: true,
      showItemMobile: true,
    },
    {
      url: 'importar',
      title: 'Importar',
      name: 'importar',
      showItem: false,
      showItemMobile: false,
      roles: []
    },
    {
      url: 'gestao-dados',
      title: 'Gestão de dados',
      name: 'gestao',
      showItem: true,
      showItemMobile: true,
      roles: [PerfilEnum.Gestor, PerfilEnum.Admin]
    },
    {
      url: 'controle-acesso',
      title: 'Controle de acesso',
      name: 'controle',
      showItem: true,
      showItemMobile: true,
      roles: [PerfilEnum.Admin]
    },
    {
      url: 'notificacoes',
      title: 'Notificações',
      name: 'notificacoes-off',
      showItem: true,
      showItemMobile: true,
    },
    {
      url: 'perfil',
      title: 'Perfil',
      name: 'perfil',
      showItem: true,
      showItemMobile: true,
    },
    {
      url: 'documentos',
      title: 'Documentos',
      name: 'documentos',
      showItem: true,
      showItemMobile: true,
      roles: [PerfilEnum.Gestor, PerfilEnum.Admin]
    }
  ];
  private pages$: BehaviorSubject<Page[]> = new BehaviorSubject<Page[]>(this.pages);

  constructor(private authService: AuthService, private platform: Platform) {
  }

  async getUser() {
    this.loadingUser = true;
    this.user = await this.authService.getUser();
    this.loadingUser = false;
  }

  updatePages(user): void {
    if (!user) {
      return;
    }
    if (this.platform.is('mobile')) {
      this.pages = this.pages.filter(x => x.showItemMobile);
    }
    for (const page of this.pages) {
      page.showItem = !(page.roles && page.roles.indexOf(user.perfil.codigo) < 0);
    }
    this.pages$.next(this.pages);
  }

  getPages() {
    this.pages$.next(this.pages);
    return this.pages$;
  }

  setContadorPages(total: number) {
    for (const page of this.pages) {
      page.badge = 0;
      if (page.url === 'notificacoes' && total > 0) {
        page.badge = total;
      }
    }
    this.pages$.next(this.pages);
  }
}
